import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import { Button, Modal } from '@canaveral/components';
import EditableRichText from '../../../../../../src/web/containers/EditableRichText';

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  description: PropTypes.shape({
    blocks: PropTypes.array.isRequired,
    entityMap: PropTypes.object.isRequired,
  }).isRequired,
  header: PropTypes.shape({
    blocks: PropTypes.array.isRequired,
    entityMap: PropTypes.object.isRequired,
  }).isRequired,
  facilityId: PropTypes.func.isRequired,
};

const defaultProps = {};

const Editor = ({
  description,
  header,
  facilityId,
  onCancelEdit,
  onFinishEdit,
}) => {
  const id = 'sm-facility-info-editor';
  const [descriptionRawContentState, setDescriptionRawContentState] = useState(description);
  const [headerRawContentState, setHeaderRawContentState] = useState(header);

  const onDescriptionChange = newRawContentState => (
    setDescriptionRawContentState(newRawContentState)
  );
  const onHeaderChange = newRawContentState => (
    setHeaderRawContentState(newRawContentState)
  );

  const onSave = async () => {
    onFinishEdit({
      header: headerRawContentState,
      description: descriptionRawContentState,
      facilityId,
    });
  };

  return (
    <Modal
      show
      onDismiss={onCancelEdit}
      aria-labelledby={id}
    >
      <Modal.Header>
        <Modal.Title id={id}>Name, Address, Phone: Facility</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-5">
          <Col xs={12}>
            <ControlLabel>Header Text</ControlLabel>
            <EditableRichText
              editing
              editorKey={id}
              onChange={onHeaderChange}
              rawContentState={headerRawContentState}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <ControlLabel>Direction or Description Text</ControlLabel>
            <EditableRichText
              editing
              editorKey={id}
              onChange={onDescriptionChange}
              rawContentState={descriptionRawContentState}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button context="neutral" size="sm" onClick={onCancelEdit}>Cancel</Button>
        <Button context="positive" size="sm" onClick={onSave}>Apply</Button>
      </Modal.Footer>
    </Modal>
  );
};

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default Editor;
